import { isLoginInEVO } from './helper';


export const isLogin = () => {
  if (import.meta.env.EVO) {
    // EVO中判断在native上是否已经登录
    return isLoginInEVO();
  }
  if (import.meta.env.SSR) {
    return false;
  }
  return !window.txv ? false : window.txv.login.isLogin();
};


export interface OpenLoginParams {
  /**
   * 登录框所在的父容器
   */
  parent?: string;
  /**
   * 是否屏蔽手机号登录
   */
  isHidePhone?: boolean;
  /**
   * 登录框标题
   */
  title?: string;
  /**
   * 退出登录标题
   */
  logoutTitle?: string;

}

export const openLogin = (params?: OpenLoginParams) => {
  if (import.meta.env.EVO) {
    const { parent, isHidePhone, title, logoutTitle } = params || {};
    let loginSSO = `qqlive://sso/login=1&parent=${parent || 'main'}`;
    // 是否屏蔽手机号登录
    if (isHidePhone) {
      loginSSO += '&hidephone=1';
    }
    // 自定义登录框标题
    if (title) {
      loginSSO += `&mainTitle=${encodeURIComponent(title)}`;
    }
    // 自定义退出登录标题，mac 端屏蔽手机号登录需要指定退出登录的title
    if (logoutTitle) {
      loginSSO += `&logoutTitle=${encodeURIComponent(logoutTitle)}`;
    }
    vnContext.external.openQQLive(loginSSO);
  } else {
    window.txv?.login.openLogin({
      showPhoneLoginEntry: !params?.isHidePhone,
    });
  }
};

// 退出登录
export const logout = (params?: OpenLoginParams) => {
  const { parent, logoutTitle } = params || {};
  let logoutSSO = `qqlive://sso/logout=1&parent=${parent || 'main'}`;
  if (logoutTitle) {
    logoutSSO += `&logoutTitle=${encodeURIComponent(logoutTitle)}`;
  }
  if (import.meta.env.EVO) {
    vnContext.external.openQQLive(logoutSSO);
  } else {
    location.href = logoutSSO;
  }
};
